import { create, filter, findOne, findAll, update } from "@/store/Crud/functions/actions";
const URL = "/student-educations";
export const selectTheoryStudentEducation = async (store, studentEducation) => {
    store.commit("SET_SELECTED_THEORY_STUDENT_EDUCATION", studentEducation);
};
export const selectPreExamStudentEducation = async (store, studentEducation) => {
    store.commit("SET_SELECTED_PREEXAM_STUDENT_EDUCATION", studentEducation);
    store.dispatch("theory-pre-exams/resetExam", {}, { root: true });
};
export const selectPreExamStudentEducationWithoutReset = async (store, studentEducation) => {
    store.commit("SET_SELECTED_PREEXAM_STUDENT_EDUCATION", studentEducation);
};
export const selectAccountStudentEducation = async (store, studentEducation) => {
    store.commit("SET_SELECTED_ACCOUNT_STUDENT_EDUCATION", studentEducation);
};
export const selectPlaygroundStudentEducation = async (store, studentEducation) => {
    store.commit("SET_SELECTED_PLAYGROUND_STUDENT_EDUCATION", studentEducation);
};
export const setLearningMode = async (store, learningMode) => {
    store.commit("SET_LEARNING_MODE", learningMode);
};
export default {
    create,
    filter,
    findOne,
    findAll,
    update,
    selectTheoryStudentEducation,
    selectPreExamStudentEducation,
    selectAccountStudentEducation,
    selectPlaygroundStudentEducation,
    setLearningMode,
    selectPreExamStudentEducationWithoutReset,
};
